/*
 *   File : verify-number.js
 *   Author URI : https://evoqins.com
 *   Description :  Component will allow the customer to submit NRI contact details.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useState } from "react";
import { CustomPhoneInput, CustomTextInput, RadioGroup } from "../../../../Component/Form-elements";
import CustomForeignInput from "../../../../Component/Form-elements/foreign-input";
import { GradientButton } from "../../../../Component/CTA";
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import APIService from "../../../../Service/api-service";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";


const VerifyNRINumber = (props) => {
    // const DECLARATION_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA);
    const [foreignMobile, setForeignMobile] = useState("");
    const [foreignMobileError, setForeignMobileError] = useState("");
    console.log('foreignMobile', foreignMobile);


    const [otpScreen, setOtpScreen] = useState(false);

    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');
    const [seconds, setSeconds] = useState(30);

    const [foreignVerified, setForeignVerified] = useState(false);


    const [apiLoader, setApiLoader] = useState(false);

    // useEffect(() => {

    //     if (DECLARATION_DATA !== null) {
    //         setForeignMobile(DECLARATION_DATA.nri_info.foreign_number);
    //         setForeignVerified(DECLARATION_DATA.nri_info.foreign_verified);
    //     }

    // }, [DECLARATION_DATA]);

    useEffect(() => {
        if (otpScreen === true) {
            const countdown = setInterval(() => {
                if (seconds > 0) {
                    setSeconds(seconds - 1);
                } else {
                    clearInterval(countdown);
                    // Handle expiration logic here (e.g., show a resend button)
                }
            }, 1000);

            return () => {
                clearInterval(countdown);
            };
        } else {
            setSeconds(30);
            setOtp("");
        }
    }, [seconds, otpScreen]);



    const _validateDetails = (type) => {
        let valid = true;
        switch (type) {
            case 1:
                if (foreignMobile === "") {
                    setForeignMobileError("Foreign Number is required");
                    valid = false
                }
                if (foreignMobile !== "" && foreignMobile.length < 8) {
                    setForeignMobileError("Invalid mobile number");
                    valid = false
                }
                if (valid === true) {
                    _sendOtpForeignNumber();
                }

                break;
            case 2:
                if (otp === '') {
                    setOtpError('OTP required');
                    return;
                } else if (!/^\d{4}$/.test(otp)) {
                    setOtpError('Invalid otp must be 4 digits');
                    return;
                } else {
                    _verifyOtpForeignNumber();
                }

                break;

            default:
                break;
        }
    }

    const getCountryFromNumber = (phoneNumber) => {
        const parsed = parsePhoneNumberFromString(phoneNumber);
        console.log(parsed)
        return parsed ? parsed : null;
    };



    // API - send OTP to foreign number
    const _sendOtpForeignNumber = (is_resend = false) => {
        setOtp('');
        if (is_resend === false) {
            setApiLoader(true);
        }
        const url = "profile/add-foreign-number";

        const phoneData = getCountryFromNumber("+" + foreignMobile);

        const payload = {
            "foreign_number": phoneData?.nationalNumber ?? null,
            "foreign_country_code": phoneData?.countryCallingCode ? "+" + phoneData.countryCallingCode : null,
        }
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.success(is_resend ? "OTP re-sent successfully to mail" : "OTP sent successfully to mail ");
                setOtpScreen(true);
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setApiLoader(false);
        });
    }


    // API - send OTP to foreign number
    const _verifyOtpForeignNumber = () => {
        setApiLoader(true);
        const url = "profile/verify-foreign-number";

        const phoneData = getCountryFromNumber("+" + foreignMobile);

        const payload = {
            "foreign_number": phoneData?.nationalNumber ?? null,
            "otp": otp,
            "foreign_country_code": phoneData?.countryCallingCode ? "+" + phoneData.countryCallingCode : null,
        }
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.success("Foreign number verified successfully");
                setForeignVerified(true);
                setOtp("");
                setOtpError("");
                // if (DECLARATION_DATA.is_review) {
                // props.updateProgress(10, 'NRI');
                // } else {
                props.updateProgress(3, "NRI")
                // }
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setApiLoader(false);
        });
    }
    return (
        <div>
            <p className="color-black e-poppins e-poppins-bold e-font-24 mb-2">Verify your mobile number</p>
            <p className="color-outer-space e-poppins-regular e-font-16 line-height-24px mb-0">
                We will collect your overseas mobile number.
            </p>
            <div className="row margin-34px-top mb-5">
                <div className="col-md-5 padding-62px-right-mob padding-5px-right-mob">
                    {
                        <>
                            <div className="position-relative">
                                <CustomForeignInput
                                    label="Enter your foreign mobile number"
                                    postfix="*"
                                    error={foreignMobileError}
                                    value={foreignMobile}
                                    excludeCountries={['in']}
                                    type='number'
                                    disabled={foreignVerified === true}
                                    isMobileInput={true}
                                    className="mt-4 mb-4"
                                    inputClass="bg-white"
                                    labelClass="bg-white"
                                    // handleChange={(e, data) => {
                                    //     setForeignMobile(e);
                                    //     setForeignMobileError("");
                                    // }} 
                                    handleChange={(e, data) => {
                                        setForeignMobile(e);
                                        setForeignMobileError("");

                                        // 🔥 Reset OTP states when user edits phone number
                                        setOtpScreen(false);     // hide OTP input
                                        setOtp("");              // clear otp
                                        setOtpError("");         // clear otp error
                                        setSeconds(30);          // reset countdown timer
                                    }}
                                />
                                {foreignVerified && <span className="position-absolute e-font-14 e-poppins-regular right-10px top-14px">
                                    <img src={require("../../../../Assets/Images/kyc/verified-check.svg").default}
                                        className="me-1" />
                                    Verified
                                </span>}
                            </div>


                            {!otpScreen &&
                                <p className="color-outer-space e-poppins-regular e-font-12 line-height-20px cursor-pointer mb-3 w-max-content">*The OTP will be sent to your registered email address.</p>
                            }



                            {otpScreen === true && (
                                <>
                                    <CustomTextInput value={otp}
                                        label={foreignVerified ? "Enter OTP received in mobile" : "Enter OTP"}
                                        type="otp"
                                        name="otp"
                                        inputClass="bg-white"
                                        labelClass="bg-white"
                                        className="mt-3 mb-4"
                                        onEnter={_validateDetails}
                                        maxLength={4}
                                        postfix="*"
                                        error={otpError}
                                        autoComplete={false}
                                        isAuthInput={true}
                                        handleChange={(e) => {
                                            setOtp(e);
                                            setOtpError("");
                                        }}
                                        require />
                                    <div className="d-flex justify-content-start mt-4 mb-4">
                                        {
                                            seconds === 0 ?
                                                <p className='color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-pointer mb-0 e-forgot-pin position-relative w-max-content'
                                                    onClick={() => {
                                                        _sendOtpForeignNumber(true);
                                                        setSeconds(30)
                                                    }}>Resend OTP</p>
                                                :
                                                <p className='color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-not-allowed mb-0 '>
                                                    Resend OTP in <span className="color-black">{seconds}s</span>
                                                </p>
                                        }

                                    </div>

                                </>
                            )}


                            <GradientButton label={otpScreen ? "Continue" : 'Verify'}
                                className='padding-14px-tb padding-16px-lr e-font-16'
                                loading={apiLoader}
                                disabled={apiLoader}
                                handleClick={() => {
                                    _validateDetails(otpScreen ? 2 : 1);
                                }} />
                        </>
                    }
                </div>
            </div>
        </div>
    )
}
export default VerifyNRINumber;